<template>
  <div>
    <BackTop :bottom="100">
      <div class="go-top">
        <Icon type="md-arrow-round-up" size="40" />
      </div>
    </BackTop>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {};
  },
  methods: { }
};
</script>
<style scoped>
.go-top {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #3370FF;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue